import './ToggleButton.css'
import cx from 'classnames'
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'
import { Spinner } from '../Spinner/Spinner'
import {
  buttonClasses,
  buttonSizeClasses,
  buttonVariantClasses,
  ButtonSize
} from '../Button/Button'

type ToggleButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  isActive: boolean
  isLoading?: boolean
  sizeType?: ButtonSize
  icon?: React.ReactNode
  iconPosition?: 'left'
  tooltip?: string
}

export function ToggleButton({
  children,
  className,
  isActive,
  isLoading,
  icon,
  iconPosition = 'left',
  sizeType = 'sm',
  ...buttonProps
}: ToggleButtonProps) {
  return (
    <button
      className={cx(
        buttonClasses.buttonBaseClassName,
        buttonSizeClasses[sizeType],
        isActive ? buttonVariantClasses.default : 'toggle-btn-inactive',
        !!icon && buttonClasses.btnBaseIcon,
        className
      )}
      {...buttonProps}
      aria-pressed={isActive}
    >
      {icon && iconPosition === 'left' && <span className="size-6">{icon}</span>}
      {isLoading ? <Spinner className="w-4 inline-block" /> : children}
    </button>
  )
}
